export const trackJSConfig = 'trackJSConfig';
export const countryandLanguageCode = { v39: 'en', v40: 'us' };
export const countryandLanguageBlankCode = { v39: '', v40: '' };
export const TRACKJSCONFIG = [
  {
    name: 'dvl4.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-login-modal'
  },
  {
    name: 'dvl1.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-login-modal'
  },
  {
    name: 'dvl2.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-login-modal'
  },
  {
    name: 'dvl3.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-login-modal'
  },
  {
    name: 'localhost',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-login-modal'
  },
  {
    name: 'st.delta.com',
    token: '155b41f470444545829ee11dc1cb03ff',
    application: 'st-login-modal'
  },
  {
    name: 'si.delta.com',
    token: '7749d424d31d404288ad07069d2775c9',
    application: 'si-login-modal'
  },
  {
    name: 'www.delta.com',
    token: '40c5d1df6a8049dfa571d3e4324bef72',
    application: 'www-login-modal'
  }
];

export enum TRACK_JS_METADATA_ENUM {
  PAGE_NAME = 'page-name',
  FILE_NAME = 'file-name',
  METHOD_NAME = 'method-name',
  EXCEPTION_CATEGORY = 'exception-category',
  EXCEPTION_MESSAGE = 'exception-message',
  APPLICATION_NAME = 'application'
}

export enum DATALAYER_PAGE_EVENTS {
  LOGIN_SUCCESS = 'login-success',
  LOGIN_UNSUCCESSFUL = 'login-unsuccessful',
  LOGIN_UNLOCK_ACCOUNT = 'login-unlock-account'
}

export enum ANALYTICS_EVENTS_LOGIN {
  RESET_PASSWORD_LOADED = 'LOGIN:resetPassword:resetPassword:loaded',
  CHECK_YOUR_EMAIL_RP_LOADED = 'LOGIN:resetPassword:checkYourEmail:loaded',
  ADDRESS_CONFIRMATION_LOADED = 'LOGIN:resetPassword:addressConfirmation:loaded',
  SECURITY_QUESTIONS_ANSWERS_LOADED = 'LOGIN:resetPassword:securityQuestionAnswers:loaded',
  RECOVERY_ACCOUNT_LOADED = 'LOGIN:resetPassword:recoverAccount:loaded',
  SET_PASSWORD_LOADED = 'LOGIN:resetPassword:setPassword:loaded',
  FORGOT_LOGIN_LOADED = 'LOGIN:forgotLogin:forgotLogin:loaded',
  CHECK_YOUR_EMAIL_FL_LOADED = 'LOGIN:forgotLogin:checkYourEmail:loaded',
  LOGOUT_SHOP_AGAIN = 'LOGIN:logoutShopAgain:loaded',
  WARM_STATE_LOGIN_CHECKOUT = 'LOGIN:warmStateLoginCheckOut:loaded'
}
